import { GrupoUnidadeDetalheUnidadeItem } from "core/features/grupo-unidades/typings";
import { useMemo } from "react";
import { Flex } from "@chakra-ui/react";
import TagStatus from "ui/components/Tags/TagStatus";
import colors from "core/resources/theme/colors";

function useGrupoUnidadesColumns() {
  return useMemo(() => {
    return [
      {
        title: "Unidade",
        width: "200px",
        render: (original: GrupoUnidadeDetalheUnidadeItem) => (
          <div>{original.nome}</div>
        ),
      },
      {
        title: "Proprietário",
        width: "400px",
        render: (original: GrupoUnidadeDetalheUnidadeItem) => (
          <div>{original.nomeMorador || "--"}</div>
        ),
      },
      {
        title: "",
        render: (original: GrupoUnidadeDetalheUnidadeItem) => (
          <Flex gap={4}>
            {original.unificada ? (
              <TagStatus color={colors.primary} status={"Unificada"} />
            ) : null}
          </Flex>
        ),
      },
    ];
  }, []);
}

export default useGrupoUnidadesColumns;
